import OAWFTrackHor from './src/track.vue';
/* istanbul ignore next */
OAWFTrackHor.install = function(Vue) {
  Vue.component('oa-wf-track-hor', OAWFTrackHor);
};
export default OAWFTrackHor;


// WEBPACK FOOTER //
// ./src/components/oa/view/official/cmps/track/track_hor/index.js